module.exports = __webpack_public_path__ + "static/media/Group 1511.22fb76de.svg";